import { useMemo } from 'react';
import { Modal } from 'react-bootstrap';
import { RxCross2 } from 'react-icons/rx';
import NewInput from 'app/components/NewInput';
import PageLoader from 'app/components/PageLoader';
import Button from 'app/components/button';
import {
  PackageMembers,
  isPackageRow,
  makePackageAwareColumns,
} from 'app/components/PackageRow';
import PaginatedTable from 'app/components/table/PaginationTable';
import { cancelVoucherTableHeader } from 'app/constants/table-header-constants';
import useCancelVoucher from './useCancelVoucher';

const CancelVoucher = () => {
  const {
    values,
    pageLoading,
    dataPerPage,
    totalNumber,
    pageCount,
    navigate,
    sectionObj,
    filteredData,
    fetchVoucherData,
    handleCheckboxChange,
    bottomButtons,
    setCurrentPage,
    currentPage,
    handleChange,
    handleSubmit,
    failedRows,
    isFailureOpen,
    handleCloseFailures,
  } = useCancelVoucher();

  // Memoised: PaginationTable memoises on the columns array's identity, so a new
  // array every render would loop on refetch.
  const columns = useMemo(
    () => makePackageAwareColumns(cancelVoucherTableHeader),
    []
  );

  return (
    <>
      <div className='cms-content__container'>
      <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
      <div className='wd-33'>
<NewInput
  label='Reserved Start Date*'
  id='startDate'
  placeholder='DD-YY-MMMM'
  name='startDate'
  format='DD-MM-YYYY'
  type={'date'}
//  min={values.endDate ? values.endDate : null }
  //max={commonMinDate()}
  value={values?.startDate}
  onChange={handleChange}
/>
</div>
<div className='wd-33'>
<NewInput
  label='Reserved End Date*'
  name='endDate'
  id='endDate'
  placeholder={'End Date'}
  //min={values.startDate ? values.startDate : commonMinDate()}
  //max={commonMinDate()}
  value={values?.endDate}
  type={'date'}
  onChange={handleChange}
/>
</div>
            <div className='wd-33 flex justify-content-start align-items-center'>
              <Button
                className='mt1'
                onClick={handleSubmit}
                variant='Save'
                name='Submit'
                isDisabled={
                !values.startDate || !values.endDate
                }
              />
            </div>
            <div></div>
          </div>
        <PaginatedTable
          sectionObj={sectionObj}
          columns={columns}
          data={filteredData}
          fulldata={filteredData}
          dataPerPage={dataPerPage}
          totalNumber={totalNumber}
          pageCount={pageCount}
          pageLoading={pageLoading}
          navigate={navigate}
          fetchData={fetchVoucherData}
          handleCheckboxChange={handleCheckboxChange}
          bottomButtons={bottomButtons}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          canExpandRow={isPackageRow}
          renderSubRow={(row) => <PackageMembers vouchers={row?.vouchers} />}
        />
      </div>
      <Modal
        show={isFailureOpen}
        onHide={handleCloseFailures}
        aria-labelledby='cancel-failures'
        centered
      >
        <div className='cursor-pointer'>
          <span className='close-icon' onClick={handleCloseFailures}>
            <RxCross2 />
          </span>
        </div>
        <Modal.Body>
          <h5 id='cancel-failures'>Some rows could not be cancelled</h5>
          <ul className='mt-3'>
            {failedRows.map((failure) => (
              <li key={failure.key}>
                {failure.label} — {failure.error}
              </li>
            ))}
          </ul>
        </Modal.Body>
      </Modal>
      <PageLoader pageLoading={pageLoading} />
    </>
  );
};

export default CancelVoucher;


